import React from "react";
import { useNavigate } from "react-router";

import { postAdminRemoveFrontendAddon } from "@/api/admin/frontendAddons";
import { postRemoveFrontendAddon } from "@/api/frontendAddons";
import { useAppAccount } from "@/components/AppProvider/AppAccountProvider";
import { FrontendAddonRaw } from "@/domain/FrontendAddon";
import { useAppRouteParams } from "../../../../../AppRoutes";
import { getDialogMessages } from "../../../DialogFirestore/helper";
import { useBulkDialog } from "../../../helpers/DialogBulk/hooks";

export const DialogFrontendAddonRemoveSome: React.FC<{
  frontendAddons: FrontendAddonRaw[];
  selectedFrontendAddonIds: string[];
  setSelectedFrontendAddonIds: React.Dispatch<React.SetStateAction<string[]>>;
  runReloadFrontendAddons: () => Promise<void>;
  returnPath: string;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({
  frontendAddons,
  selectedFrontendAddonIds,
  setSelectedFrontendAddonIds,
  runReloadFrontendAddons,
  returnPath,
  open,
  setOpen,
}) => {
  const { organizationId } = useAppRouteParams();
  const { isAADeveloperOrAbove } = useAppAccount();
  const navigate = useNavigate();

  const selectedAddons = React.useMemo(
    () => frontendAddons.filter((a) => selectedFrontendAddonIds.includes(a.id)),
    [frontendAddons, selectedFrontendAddonIds]
  );

  const runRemove = async (addon: FrontendAddonRaw) => {
    isAADeveloperOrAbove
      ? await postAdminRemoveFrontendAddon({
          frontendAddonId: addon.id,
        })
      : await postRemoveFrontendAddon({
          organizationId,
          frontendAddonId: addon.id,
        });
  };

  const messages = getDialogMessages({
    isSome: true,
    actionType: "delete",
    targetType: "frontendAddon",
  });

  const { renderBulkDialogs } = useBulkDialog<"id", FrontendAddonRaw>({
    ...messages.confirm,
    rows: selectedAddons,
    rowKey: "id",
    run: runRemove,
    isThemeRed: true,
    renderItem: (addon) => {
      return <div>{addon.name}</div>;
    },
    open,
    onClose: ({ states }) => {
      setOpen(false);
      setSelectedFrontendAddonIds(
        states.filter((s) => s.status !== "success").map((s) => s.id)
      );
      runReloadFrontendAddons();
      navigate(returnPath);
    },
  });

  return <>{renderBulkDialogs()}</>;
};
